import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  container: {
    minHeight: '70vh',
    maxHeight: '150vh',
  },
  reportContainer: {
    height: (props: { dashboardHeight?: number }) =>
      props?.dashboardHeight ? `${props?.dashboardHeight}px` : '130vh',
    width: '100%',
    margin: '1% auto',

    '& > iframe': {
      border: 'none',
    },
  },
});

export default useStyles;
